import classNames from 'classnames';
import FJImageInputTwo from '../../../../common/components/FJImageInput/FJImageInputTwo';
import FJLocalStore from '../../../../store/FJLocalStore';
import styles from './FJVideoRemoveBgCustomLeft.module.less';
import PropTypes from 'prop-types';
import FJVideoRemoveBgCustomObjectPreviewContainer from '../container/FJVideoRemoveBgCustomObjectPreviewContainer';
import FJGenerateButton from '../../../../common/components/FJGenerateButton/FJGenerateButton';
import FJButton, { FJButtonType } from '../../../../common/components/FJButton/FJButton';
import FJCreationsIcon from '../../../../assets/svg/credits-min.svg?react';
import { ID_LIST } from '../../../../redux/slices/FJSliceVideoBgRemover';
import FJConstant from '../../../../constants/FJConstant';
import { FJVideoRemoveBgDataConfig } from '../../../../config/dataConfig/FJVideoRemoveBgDataConfig';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller';

const FJVideoRemoveBgCustomLeft = ({
    uploadVideo,
    isFree,
    useCredit,
    freeNumCreation,
    editVideoInfo,
    isShow,
    hasPointLoading,
    onGenerate,
    customRemoverStatus,
    isProjectLoading,
    isTrimVideo,
    onRemoveAll,
    customIsUploading,
    uploadBeforeCallback,
}) => {
    return (
        <div className={classNames(styles.custom_left, { [styles.show]: isShow })}>
            <FJVerticalScroller
                className={classNames(styles.scroller, {
                    [styles.scroller_trim]: isTrimVideo,
                })}
            >
                <FJImageInputTwo
                    uploadImg={uploadVideo}
                    isUploadVideoFile={true}
                    isLoading={customIsUploading}
                    disabled={
                        hasPointLoading ||
                        customRemoverStatus === FJConstant.START ||
                        customRemoverStatus === FJConstant.GENERATING ||
                        customRemoverStatus === FJConstant.LOADING
                    }
                    text={'click-or-drag-to-upload-video'}
                    btnText={'upload-video'}
                    btnClassName={styles.btn}
                    smallText={FJLocalStore._('upload-video')}
                    isIconRight={true}
                    isJudgeLogin={true}
                    isSmallComponent={!!editVideoInfo}
                    uploadBeforeCallback={uploadBeforeCallback}
                    acceptFile={FJVideoRemoveBgDataConfig.ACCEPT_FILE_TYPE}
                    // icon={
                    //     <div className={styles.use_credit}>
                    //         {FJLocalStore._('xxx-credits-s').replace('xxx', VIDEO_REMOVE_BG_USE_CREDIT)}
                    //     </div>
                    // }
                />

                <FJVideoRemoveBgCustomObjectPreviewContainer isShow={!!editVideoInfo} />
            </FJVerticalScroller>

            {!!editVideoInfo && (
                <>
                    <FJGenerateButton
                        disabled={hasPointLoading || customRemoverStatus !== FJConstant.DEFAULT}
                        onClick={onGenerate}
                        taskStatus={customRemoverStatus}
                        freeNumCreation={freeNumCreation}
                        isFree={isFree}
                        useCredit={useCredit}
                        isProjectLoading={isProjectLoading}
                        style={{ marginTop: '24px' }}
                        isShowUsageDetail={true}
                        text={
                            customRemoverStatus === FJConstant.DEFAULT ||
                            customRemoverStatus === FJConstant.ERROR ||
                            customRemoverStatus === FJConstant.SOURCE_LOADING_ERROR
                                ? isTrimVideo
                                    ? FJLocalStore._('remove-xxx-background').replace('xxx', '5s')
                                    : 'remove'
                                : null
                        }
                        id={ID_LIST.REMOVE_BG_CUSTOM_GENERATE_BTN}
                    />

                    {isTrimVideo && (
                        <FJButton
                            disabled={hasPointLoading || customRemoverStatus !== FJConstant.DEFAULT}
                            className={styles.remove_all_btn}
                            textClassName={styles.remove_all_text}
                            type={FJButtonType.CREDIT}
                            onClick={onRemoveAll}
                            icon={<FJCreationsIcon className={styles.remove_all_icon} />}
                            text={'remove-all'}
                        />
                    )}
                </>
            )}
        </div>
    );
};

FJVideoRemoveBgCustomLeft.propTypes = {
    uploadVideo: PropTypes.func,
    isFree: PropTypes.bool,
    useCredit: PropTypes.number,
    freeNumCreation: PropTypes.number,
    editVideoInfo: PropTypes.object,
    isShow: PropTypes.bool,
    onGenerate: PropTypes.func,
    isProjectLoading: PropTypes.bool,
    hasPointLoading: PropTypes.bool,
    customRemoverStatus: PropTypes.string,
    onRemoveAll: PropTypes.func,
    isTrimVideo: PropTypes.bool,
    customIsUploading: PropTypes.bool,
    uploadBeforeCallback: PropTypes.func,
};

export default FJVideoRemoveBgCustomLeft;
